import { ActivatedRoute } from "@angular/router";
import AIDecorator from "./AIDecorator";
import { Injector } from "@angular/core";

export default class AIProgressNote extends AIDecorator {


    setInitialValue: boolean = true;
    template_mandatory_check: boolean = true;
    template_mandatory_status: boolean = false;
    ishit: boolean = false;
    currentTemplateId: string = "";
  
    constructor(
      public route: ActivatedRoute,
      public name = 'AIProgressNote',
      public injector: Injector
    ) {
      super(route, name, injector);
     
    }

    processFilter(filter,config) {
      var currentData= this.storageService.getSessionStorageDataSync('currentData');
      filter = this.baseService.buildDyanamicStr((filter)?filter:'', { data: currentData });
      return filter
  }
}
  